export const MS_IN_DAY: number = 86400000;
export const DAYS_IN_YEAR: number = 365;
export const APPA_BIRTHDAY: string = '10/22/2022';
export const APPA_GOTCHADAY: string = '1/27/2023';
export const MOMO_BIRTHDAY: string = '1/19/2022';
export const MOMO_GOTCHADAY: string = '3/14/2023';